import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-.047-11.512.662 1.804h-1.283zm1.687 4.596-.29-.792h-2.706l-.266.773a1 1 0 0 1-1.891-.65l2.146-6.24c.422-1.224 2.146-1.241 2.592-.027l2.293 6.247a1 1 0 0 1-1.878.689",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_automatic_filled-BJ5DKaLo.js.map
